import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import ReleaseMetricsComponent from './../Components/ReleaseMetricsComponent';

import {
  builds as buildActions,
  fetchJobBuildsByBuildIds,
  jira as jiraActions,
  jobs as jobActions,
  metrics as metricsActions,
  params as paramActions
} from './../actions';
import {
  buildsByBuildTypes,
  getJobsByName,
  releaseMetricsPageReducer
} from './../reducers';
import { LATEST_RELEASE, BUILD_RELEASE } from '../helpers/build';
import { jobNames, auth } from '../helpers';

export class ReleaseMetricsContainer extends React.Component {
  static propTypes = {
    builds: PropTypes.array.isRequired,
    caseMetricsJobs: PropTypes.array.isRequired,
    perfJobs: PropTypes.array.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    product: PropTypes.string.isRequired,
    fetchBuildsSinceByType: PropTypes.func.isRequired,
    fetchJobBuildsByBuildIds: PropTypes.func.isRequired,
    fetchJobsByBuildIds: PropTypes.func.isRequired,
    fetchParamsByJobIds: PropTypes.func.isRequired,
    fetchMetricsByJobIds: PropTypes.func.isRequired,
    refreshScans: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.fetchBuildsSinceByType(BUILD_RELEASE);
    this.props.refreshScans();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.builds &&
      this.props.builds.length > 0 &&
      this.props.builds !== prevProps.builds
    ) {
      const buildIds = this.props.builds.map(b => b.id);

      this.props.fetchJobBuildsByBuildIds(buildIds);
      this.props.fetchJobsByBuildIds(buildIds);
    }

    const relevantJobs = [
      ...this.props.caseMetricsJobs,
      ...this.props.perfJobs
    ];

    if (
      relevantJobs &&
      relevantJobs.length > 0 &&
      this.props.caseMetricsJobs !== prevProps.caseMetricsJobs &&
      this.props.perfJobs !== prevProps.perfJobs
    ) {
      const jobIds = relevantJobs.map(j => j.id);
      this.props.fetchParamsByJobIds(jobIds);
      this.props.fetchMetricsByJobIds(jobIds);
    }
  }

  render() {
    return (
      <ReleaseMetricsComponent
        isAuthenticated={this.props.isAuthenticated}
        product={this.props.product}
      />
    );
  }
}

export const mapStateToProps = (state) => {
  const buildsByType = buildsByBuildTypes(state);
  const info = releaseMetricsPageReducer.getReleaseMetricsInfo(state);
  return {
    builds: buildsByType[LATEST_RELEASE] || [],
    caseMetricsJobs: getJobsByName(state, jobNames.CASE_METRICS) || [],
    perfJobs: getJobsByName(state, jobNames.PERFORMANCE) || [],
    isAuthenticated: auth.checkAuthenticated(),
    product: info.product
  };
};

export default connect(
  mapStateToProps,
  {
    fetchBuildsSinceByType: buildActions.fetchBuildsSinceByType,
    fetchJobBuildsByBuildIds,
    fetchJobsByBuildIds: jobActions.fetchJobsByBuildIds,
    fetchParamsByJobIds: paramActions.fetchParamsByJobIds,
    fetchMetricsByJobIds: metricsActions.fetchMetricsByJobIds,
    refreshScans: jiraActions.refreshScans
  }
)(ReleaseMetricsContainer);


// WEBPACK FOOTER //
// src/Containers/ReleaseMetricsContainer.jsx